import { Action } from '@ngrx/store';

export enum TenantActionTypes {
  TENANT_NEW = '[TENANT_NEW] Add tenant',
  TENANT_ALL = '[TENANT_NEW] Get ALL',
}

export class TenantAll implements Action {
  readonly type = TenantActionTypes.TENANT_ALL;
}

export class TenantNovo implements Action {
  readonly type = TenantActionTypes.TENANT_NEW;
  constructor(public payload: { operacionalTenant: object }) {}
}

export type TenantActions = TenantNovo | TenantAll;
